export default [
    'zhixuebao/zhixuebao',
    'zhixuebao/base',
    'zhixuebao/report',
    // 'addon/error',
  ];


// WEBPACK FOOTER //
// ./src/api/reportCloudUrl.js